/**
 * @generated SignedSource<<097b0c53d42b6a6ff88a389bbf1d86ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchiveFlowInput = {
  clientMutationId?: string | null | undefined;
  flowId: UUID;
};
export type AssignmentOptionsMutation$variables = {
  input: ArchiveFlowInput;
};
export type AssignmentOptionsMutation$data = {
  readonly archiveFlow: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type AssignmentOptionsMutation = {
  response: AssignmentOptionsMutation$data;
  variables: AssignmentOptionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveFlowPayload",
    "kind": "LinkedField",
    "name": "archiveFlow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentOptionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentOptionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1455ef61828699660d8de5b1ad849029",
    "id": null,
    "metadata": {},
    "name": "AssignmentOptionsMutation",
    "operationKind": "mutation",
    "text": "mutation AssignmentOptionsMutation(\n  $input: ArchiveFlowInput!\n) {\n  archiveFlow(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "964752eaa27998d4f62ebd4850174366";

export default node;
